// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2BIY9","title":"FrontImage_title__85icu"};